// Navigation Bar SECTION
const navBar = {
  show: true,
};

// Main Body SECTION
const mainBody = {
  gradientColors: "#4484ce, #1ad7c0, #ff9b11, #9b59b6, #ff7f7f, #ecf0f1",
  firstName: "Kyle",
  middleName: "",
  lastName: "Connolly",
  message: " Full Stack Web Developer with 8 years of Experience ",
  icons: [
    {
      image: "fa-github",
      url: "https://github.com/kyleconnolly1020",
    },
    {
      image: "fa-linkedin",
      url: "https://www.linkedin.com/in/kyleconnollyusc/",
    },
    {
      image: "fa-envelope",
      url: "mailto:kyleconnolly1020@gmail.com",
    },
  ],
};

// ABOUT SECTION
// If you want the About Section to show a profile picture you can fill the profilePictureLink either with:
//a) your Instagram username
//      i.e:profilePictureLink:"johnDoe123",
//b) a link to an hosted image
//      i.e:profilePictureLink:"www.picturesonline.com/johnDoeFancyAvatar.jpg",
//c) image in "editable-stuff" directory and use require("") to import here,
//      i.e: profilePictureLink: require("../editable-stuff/kyleconnolly.png"),
//d) If you do not want any picture to be displayed, just leave it empty :)
//      i.e: profilePictureLink: "",
// For Resume either provide link to your resume or import from "editable-stuff" directory
//     i.e resume: require("../editable-stuff/resume.pdf"),
//         resume: "https://docs.google.com/document/d/1KC-eWKiT09e8Me2yApaTsguo1YG2I3f34Gx_AZuctEk/edit?usp=sharing",

const about = {
  show: true,
  heading: "About Me",
  imageLink: require("../editable-stuff/kyleconnolly.png"),
  imageSize: 375,
  message:
  "My name is Kyle Connolly. I'm a full stack web developer with 8 years of experience. I'm passionate about creating technology that has a lasting impact, and my goal is to contribute to global betterment using my knowledge of software engineering. In my free time I like building projects using machine learning and computer vision.",
  resume: "https://docs.google.com/document/d/1KC-eWKiT09e8Me2yApaTsguo1YG2I3f34Gx_AZuctEk/edit?usp=sharing",
};

// PROJECTS SECTION
// Setting up project lenght will automatically fetch your that number of recently updated projects, or you can set this field 0 to show none.
//      i.e: reposLength: 0,
// If you want to display specfic projects, add the repository names,
//      i.e ["repository-1", "repo-2"]
const repos = {
  show: true,
  heading: "Some Projects",
  gitHubUsername: "kyleconnolly1020", 
  reposLength: 4,
  specificRepos: [],
};

// Leadership SECTION
const leadership = {
  show: false,
  heading: "Leadership",
  message:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Vitae auctor eu augue ut lectus arcu bibendum at varius. Libero justo laoreet sit amet cursus sit amet. Imperdiet dui accumsan sit amet nulla facilisi morbi. At auctor urna nunc id. Iaculis urna id volutpat lacus laoreet non curabitur gravida. Et magnis dis parturient montes nascetur ridiculus mus mauris. In nisl nisi scelerisque eu ultrices vitae auctor. Mattis nunc sed blandit libero volutpat sed cras ornare. Pulvinar neque laoreet suspendisse interdum consectetur libero.",
  images: [
    { 
      img: require("../editable-stuff/kyleconnolly.png"), 
      label: "First slide label", 
      paragraph: "Nulla vitae elit libero, a pharetra augue mollis interdum." 
    },
    { 
      img: require("../editable-stuff/kyleconnolly.png"), 
      label: "Second slide label", 
      paragraph: "Nulla vitae elit libero, a pharetra augue mollis interdum." 
    },
  ],
  imageSize: {
    width:"615",
    height:"450"
  }
};

// SKILLS SECTION
const skills = {
  show: true,
  heading: "Skills",
  hardSkills: [
    { name: "Javascript" },
    { name: "Python" },
    { name: "React" },
    { name: "Node.JS" },
    { name: "Go" },
    { name: "GraphQL" },
    { name: "HTML" },
    { name: "CSS" },
    { name: "SQL" },
    { name: "AWS" },
    { name: "C#" },
    { name: "MongoDB" },
    { name: "DynamoDB" },
    { name: "Ionic" }
  ]
};

// GET IN TOUCH SECTION
const getInTouch = {
  show: true,
  heading: "Get In Touch",
  message:
    "I'm currently looking for full-time Software Engineering or Machine Learning opportunities! If you know of any positions available, have any questions, or would just like to say hi, please feel free to reach me at",
  email: "kyleconnolly1020@gmail.com",
};

const experiences = {
  show: false,
  heading: "Experiences",
  // data: [
  //   {
  //     role: 'Software Engineer',
  //     companylogo: require('../assets/img/dell.png'),
  //     date: 'June 2018 – Present',
  //   },
  //   {
  //     role: 'Front-End Developer',
  //     companylogo: require('../assets/img/boeing.png'),
  //     date: 'May 2017 – May 2018',
  //   },
  // ]
}

// Blog SECTION
// const blog = {
//   show: false,
// };

export { navBar, mainBody, about, repos, skills, leadership, getInTouch, experiences };
